import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from "./components/Footer";
import DomainQueryLanding from './components/DomainQueryLanding';
import DomainQueryAndroidPrivacy from './components/DomainQueryAndroidPrivacy';
import DomainQueryIosPrivacy from './components/DomainQueryIosPrivacy';
import DomainQuerySupport from './components/DomainQuerySupport';

// Portfolio Homepage Component
const Portfolio = () => {
  return (
    <div>
      <Helmet>
        <title>Ahnaf Mahmud</title>
      </Helmet>
      <Navbar />
      <Home />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/apps/DomainQuery" element={<DomainQueryLanding />} />
        <Route path="/apps/DomainQuery/privacy-android.html" element={<DomainQueryAndroidPrivacy />} />
        <Route path="/apps/DomainQuery/privacy-ios.html" element={<DomainQueryIosPrivacy />} />
        <Route path="/apps/DomainQuery/support.html" element={<DomainQuerySupport />} />
      </Routes>
    </Router>
  );
}

export default App;